import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalDeficiencyTicketWatchersDbTableDefinition extends DbTableDefinition {
  tableName = 'local_deficiencyTicketWatchers';
  tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
     watcherobjref VARCHAR(45),
     watcherid BIGINT(20),
     deficiencyticketid BIGINT(20),
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(45, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
